module.exports = __webpack_public_path__ + "static/actionbar-actions-do-48302c4145785359d138beaa9cf0fe78.png";